import { createSlice } from '@reduxjs/toolkit';
import { subDays } from 'date-fns';

// utils
import axios from 'utils/axios';
import { ACTIONS, ERRORS, INS_MAX_LENGTH } from 'utils/constants';
import { fDate, fDateTime, getDateTimeValue, validateDates } from 'utils/formatTime';

// utils 
import { decrypt } from 'utils/crypto';

import API from 'restApi';
import { dispatch, store } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  prevFilters: null,
  examsListFiltred: [],
  patients: [],
  isLinkDemo: false,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },
  filters: {
    eye: false,
    urgent: false,
    recudu: null,
    recuau: null,
    hourFrom: null,
    hourTo: null,
    ddn: null,
    ipp: "",
    ins: "",
    nohosp: "",
    nom: "",
    nomdenaissance: "",
    examFilter: null,
    levyFrom: null,
    levyTo: null,
    levyHourFrom: new Date(2014, 8, 1, 0, 0.5),
    levyHourTo: new Date(),
    prenom: "",
    // sihpresents: false,
    // sihsortis: false,
    finished: false,
    supported: false,
    cancelled: false,
    inprogress: false,
    modified: false,
  },
};

const slice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSubReceivedFromDate(state, action) {
      state.filters = {
        ...state.filters,
        recuau: new Date(),
        hourTo: new Date(),
        recudu: subDays(new Date(), action.payload),
        hourFrom: new Date(2014, 8, 1, 0, 0.5)
      };
    },
    setLinkDemo(state, action) {
      state.isLinkDemo = action.payload;
    },
    // GET Patients
    getPatientsSuccess(state, action) {
      const { patients, navig } = action.payload;
      state.isLoading = false;
      state.patients = patients;
      state.navig = navig;
      state.error = null;

    },
    // GET Contract
    getPatientsuccess(state, action) {
      state.isLoading = false;
      state.demand = action.payload;
    },

    //  SORT & FILTER Patients
    sortByPatients(state, action) {
      state.sortBy = action.payload;
    },
    //  pagination Patients
    paginationPatients(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    //  reset pagination Patients
    resetPaginationPatients(state) {
      state.navig = initialState.navig;
    },
    setHourTo(state, action) {
      state.filters.hourTo = action.payload;
    },
    filterPatients(state, action) {
      state.filters = action.payload;
    },
    resetPatients(state) {
      state.patients = initialState.patients;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    },
    onSaveFilter(state, action) {
      state.prevFilters = action.payload;
    },
    onSaveExamsListFiltred(state, action) {
      state.examsListFiltred = action.payload;
    },
    decrementDemandNotRead(state, action) {
      const ipp = action.payload;

      // Find the index of the patient in the state
      const patientIndex = state.patients.findIndex(patient => patient.ipp === ipp);

      // If the patient is found, update the non_lu property
      if (patientIndex !== -1) {
        // Decrement non_lu if it's greater than 0
        if (state.patients[patientIndex].non_lues > 0) {
          state.patients[patientIndex].non_lues -= 1;
        }
      }
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  sortByPatients,
  paginationPatients,
  filterPatients,
  resetPatients,
  hasError,
  onSaveFilter,
  setLoading,
  setSubReceivedFromDate,
  setLinkDemo,
  resetPaginationPatients,
  onSaveExamsListFiltred,
  decrementDemandNotRead,
  setHourTo
} = slice.actions;

// ----------------------------------------------------------------------


export function getPatients() {
  const { patient: { filters, navig }, all: { config } } = store.getState();

  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      const { user: { usercode }, profile, allActorsSelected, allFavoriteActorsSelected, actorsSelected } = decrypt(JSON.parse(window.sessionStorage.getItem('storage')));
      const receiptFromDate = getDateTimeValue({ dateValue: filters.recudu, hourValue: filters.hourFrom });
      const receiptToDate = getDateTimeValue({ dateValue: filters.recuau, hourValue: filters.hourTo });
      const errorsValidationOne = validateDates({ start: receiptFromDate, end: receiptToDate });

      const levyFromDate = getDateTimeValue({ dateValue: filters.levyFrom, hourValue: filters.levyHourFrom });
      const levyToDate = getDateTimeValue({ dateValue: filters.levyTo, hourValue: filters.levyHourTo });
      const errorsValidationTwo = validateDates({ start: levyFromDate, end: levyToDate, startLabel: 'LEVY_START_DATE', endLabel: 'LEVY_END_DATE' });
      const date5 = new Date(filters.ddn).getTime();
      const errorsValidationThree = validateDates({ start: date5, end: null, startLabel: 'DDN_DATE' });
      const ins = filters.ins?.replace(/\s/g, '');
      const errors = { ...errorsValidationOne, ...errorsValidationTwo, ...errorsValidationThree };
      let receiptDateMoreThanOneMonthMoreThanMonth = false;
      let levyFromDateMoreThanOneMonthMoreThanMonth = false;

      if (!filters.name &&
        !filters.ddn &&
        !filters.ipp &&
        !filters.nom &&
        !filters.nomdenaissance &&
        !filters.prenom &&
        !filters.ins
      ) {
        if (!!receiptFromDate && !!receiptToDate) {

          const startDate = new Date(filters.recudu);
          const endDate = new Date(filters.recuau);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          const oneMonthLater = startDate;
          oneMonthLater.setMonth(startDate.getMonth() + 1);

          if (endDate > oneMonthLater) {
            receiptDateMoreThanOneMonthMoreThanMonth = true;
          }
        }
        else if (!receiptFromDate && !receiptToDate) {
          receiptDateMoreThanOneMonthMoreThanMonth = true;
        }
        else if (!receiptFromDate && !!receiptToDate) {
          receiptDateMoreThanOneMonthMoreThanMonth = true;
        }
        else if (!!receiptFromDate && !receiptToDate) {
          const startDate = new Date(filters.recudu);
          const endDate = new Date();
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          const oneMonthLater = startDate;
          oneMonthLater.setMonth(startDate.getMonth() + 1);
          if (endDate > oneMonthLater) {
            receiptDateMoreThanOneMonthMoreThanMonth = true;
          }
        }
        if (!!levyFromDate && !!levyToDate) {

          const startDate = new Date(filters.levyFrom);
          const endDate = new Date(filters.levyTo);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          const oneMonthLater = startDate;
          oneMonthLater.setMonth(startDate.getMonth() + 1);

          if (endDate > oneMonthLater) {
            levyFromDateMoreThanOneMonthMoreThanMonth = true;
          }
        }
        else if (!levyFromDate && !levyToDate) {
          levyFromDateMoreThanOneMonthMoreThanMonth = true;
        }
        else if (!levyFromDate && !!levyToDate) {
          levyFromDateMoreThanOneMonthMoreThanMonth = true;
        }
        else if (!!levyFromDate && !levyToDate) {
          const startDate = new Date(filters.levyFrom);
          const endDate = new Date();
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          const oneMonthLater = startDate;
          oneMonthLater.setMonth(startDate.getMonth() + 1);
          if (endDate > oneMonthLater) {
            levyFromDateMoreThanOneMonthMoreThanMonth = true;
          }
        }

        if (levyFromDateMoreThanOneMonthMoreThanMonth && receiptDateMoreThanOneMonthMoreThanMonth) {
          throw new Error('moreThanOneMonth');
        }
      }



      if (ins !== '' && ins?.length < INS_MAX_LENGTH)
        errors.INS = ERRORS.ins;

      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });

      let examCodes;
      if (filters.examFilter) {
        examCodes = await getExamCode(filters.examFilter);
      }
      const response = await axios.post(API.path, {
        criteres: {
          usercode,
          actorsSelected: actorsSelected.map(item => item.actorCode),
          profile,
          ...filters,
          prescrFilter: filters.prescrFilter?.map(item => item.actorCode),
          examFilter: filters.examFilter ? examCodes : [filters.examFilter],
          ddn: filters.ddn ? fDate(filters.ddn) : '',
          recudu: filters.recudu ? `${fDateTime(receiptFromDate)}:00` : '',
          recuau: filters.recuau ? `${fDateTime(receiptToDate)}:59` : '',
          preldu: filters.levyFrom ? fDateTime(levyFromDate) : '',
          prelau: filters.levyTo ? fDateTime(levyToDate) : '',
          ins,
          allActorsSelected,
          allFavoriteActorsSelected
        },
        navig: {
          total: 0,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.SEARCHPATIENT
      });

      const { data } = response;
      if (data.statut === "OK") {
        dispatch(slice.actions.getPatientsSuccess(data));
        if (data.patients.length === 0) {
          throw new Error('NO_RESULTS');
        }
      } else {
        dispatch(slice.actions.setLoading(false));
      }


    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}

export async function getDemandsForPatient(ipp) {
  const { patient: { filters } } = store.getState();
  try {
    const { user: { usercode }, profile, allFavoriteActorsSelected, allActorsSelected, actorsSelected } = decrypt(JSON.parse(window.sessionStorage.getItem('storage')));
    const receiptFromDate = getDateTimeValue({ dateValue: filters.recudu, hourValue: filters.hourFrom });
    const receiptToDate = getDateTimeValue({ dateValue: filters.recuau, hourValue: filters.hourTo });

    const levyFromDate = getDateTimeValue({ dateValue: filters.levyFrom, hourValue: filters.levyHourFrom });
    const levyToDate = getDateTimeValue({ dateValue: filters.levyTo, hourValue: filters.levyHourTo });
    const ins = filters.ins?.replace(/\s/g, '');
    let examCodes;
    if (filters.examFilter) {
      examCodes = await getExamCode(filters.examFilter);
    }

    const response = await axios.post(API.path, {
      criteres: {
        ...filters,
        usercode,
        ipp,
        profile,
        actorsSelected: actorsSelected.map(item => item.actorCode),
        prescrFilter: filters.prescrFilter?.map(item => item.actorCode),
        examFilter: filters.examFilter ? examCodes : [filters.examFilter],
        ddn: filters.ddn ? fDate(filters.ddn) : '',
        recudu: filters.recudu ? `${fDateTime(receiptFromDate)}:00` : '',
        recuau: filters.recuau ? `${fDateTime(receiptToDate)}:59` : '',
        preldu: filters.levyFrom ? fDateTime(levyFromDate) : '',
        prelau: filters.levyTo ? fDateTime(levyToDate) : '',
        ins,
        allActorsSelected,
        allFavoriteActorsSelected
      },
      action: ACTIONS.LOADDEMANDSFORPATIENT
    });
    const { data } = response;
    if (data.demands === undefined) {
      throw new Error('NO_RESULTS');
    }
    return data;
  } catch (error) {
    dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    return null;
  }
}

export async function getExamCode(examFilter) {
  try {
    const actor = examFilter?.filterCode.split('~')[1];
    const filterResponse = await axios.post(API.path, {
      action: ACTIONS.LOADFILTER,
      criteres: {
        filtercode: examFilter?.filterCode,
        actorcode: actor === 'ALL' ? '' : actor
      }

    });
    return filterResponse.data.data.examFilter?.map((item) => item.examcode);

  } catch (e) {
    throw new Error("NO_FILTER");
  }

}

